module.exports = __webpack_public_path__ + "static/media/block-3-ipswich.61e101ae.png";